export const Codecs = {
  vp8: 'vp8',
  vp9: 'vp9',
  h264: 'h264',
};